import { differenceInYears, isValid } from 'date-fns';

const getAgeFromDOB = (dateString: string | Date): number | null => {
  if (!isValid(new Date(dateString))) return null;
  return differenceInYears(new Date(), new Date(dateString));
};

export default getAgeFromDOB;
